import { AcronymType } from '../../types/AcronymTypes';
import { CHANGE_ACRONYMS_FILTER, UPDATED_SELECTED_ACRONYMS } from '../actionTypes';

const initialState: any = {
  acronyms: [],
  filter: null,
};

export default function acronyms(state = initialState, action: any) {
  switch (action.type) {
    case UPDATED_SELECTED_ACRONYMS: {
      return { ...state, acronyms: action.payload as AcronymType[] };
    }
    case CHANGE_ACRONYMS_FILTER: {
      return { ...state, filter: action.payload };
    }
    default:
      return state;
  }
}
